import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { auth } from "../../../firebase";
import { sendPasswordResetEmail as _sendPasswordResetEmail } from "firebase/auth";
import { isValidEmail } from "../../../shared/utility";
import { ETranslation } from "../../../translations/translation-keys";
import Alert, { EAlertColor } from "../../UI/Alert/Alert";
import Button from "../../UI/Button/Button";
import { EInputType } from "../../UI/Input/Input";
import InputGroup from "../../UI/InputGroup/InputGroup";
import Spinner from "../../UI/Spinner/Spinner";
import classes from "./PasswordResetDialog.module.scss";

interface IProps {
  onCancel: () => void;
}

const PasswordResetDialog: React.FC<IProps> = ({ onCancel }) => {
  const { t } = useTranslation();

  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  const sendPasswordResetEmail = () => {
    if (email) {
      setLoading(true);
      setError(null);
      
      _sendPasswordResetEmail(auth, email)
        .then(() => {
          setSuccess(true);
        })
        .catch((err) => {
          console.error("Password reset error:", err);
          if (err.code === 'auth/user-not-found') {
            setError("Käyttäjää ei löytynyt tällä sähköpostiosoitteella. Tarkista oikeinkirjoitus.");
          } else {
            setError("Sähköpostin lähetys epäonnistui. Tarkista osoite tai yritä myöhemmin uudelleen.");
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <div>
      {success ? (
        <div>
          <Alert color={EAlertColor.SUCCESS} style={{ marginBottom: "1rem" }}>
            Salasanan palautuslinkki on lähetetty sähköpostiisi.
          </Alert>
          <Button onClick={onCancel}>{t(ETranslation.COMMON_CLOSE)}</Button>
        </div>
      ) : (
        <div>
          <p>{t(ETranslation.PASSWORD_RESET_TEXT)}</p>
          {error && (
            <Alert color={EAlertColor.DANGER} style={{ marginBottom: "1rem" }}>
              {error}
            </Alert>
          )}
          <div>
            <input
              className={classes.Input}
              placeholder={t(ETranslation.COMMON_EMAIL)}
              type={EInputType.email}
              value={email as string}
              onChange={event => {
                const value = event && event.target && event.target.value;
                setEmail(value as string)
              }}
              disabled={loading}
            />
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <InputGroup>
              <Button disabled={!isValidEmail(email)} onClick={sendPasswordResetEmail}>{t(ETranslation.COMMON_SEND)}</Button>
              <Button onClick={onCancel}>{t(ETranslation.COMMON_CANCEL)}</Button>
            </InputGroup>
          )}
        </div>
      )}
    </div>
  )
}

export default PasswordResetDialog;
